module.exports = __webpack_public_path__ + "static/img/13.0c48a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/13.png
// module id = dvkY
// module chunks = 0